import { Trash } from 'lucide-react'
import { useEffect, useState } from 'react'

import { IconButton, ImageContainer, Text } from '@/components'
import { cn } from '@/lib/utils'

interface InputImageItemProps {
  file: File
  index: number
  remove: (index: number) => void
}

export default function Component({
  index,
  file,
  remove,
}: InputImageItemProps) {
  const [dataURL, setDataURL] = useState<string | ArrayBuffer | null>(null)

  useEffect(() => {
    if (!file) return

    const reader = new FileReader()
    reader.onabort = () => console.log('file reading was aborted')
    reader.onerror = () => console.log('file reading has failed')
    reader.onload = () => setDataURL(reader.result)
    reader.readAsDataURL(file)
  }, [file])

  if (!file) return null

  return (
    <div
      className={cn(
        'grid grid-cols-[auto,1fr,auto] gap-2',
        'rounded-lg border border-muted-foreground/20',
        'overflow-hidden bg-background pr-2',
      )}
    >
      <div>
        <ImageContainer
          src={dataURL as string}
          alt="preview"
          className="max-h-32 w-32 object-contain object-center"
        />
      </div>

      <div className="flex flex-col justify-center overflow-hidden">
        <Text
          variant="strong"
          className="overflow-hidden text-ellipsis text-nowrap text-xs"
        >
          {file.name}
        </Text>
        <Text variant="soft" className="text-xs">
          {Number(file.size / 1000).toFixed(2)} KB
        </Text>
      </div>

      <div className="flex items-center">
        <IconButton
          icon={Trash}
          type="button"
          variant="outline"
          onClick={() => remove(index)}
        />
      </div>
    </div>
  )
}
